import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { GameContext } from '../../core/context/game.context';
import './score.style.scss';

export default function Score({ partial, updateTo = 0 }: { partial: number; updateTo?: number }) {
  const [partialState, setPartialState] = React.useState<number>(partial);
  const toRef = React.useRef<number>();
  const { t } = useTranslation();
  const gameCtx = useContext(GameContext);
  const theme = gameCtx.getTheme();

  React.useEffect(() => {
    window.clearTimeout(toRef.current);
    toRef.current = window.setTimeout(() => {
      setPartialState(partial);
    }, updateTo * 1000);
  }, [partial, updateTo]);

  return (
    <section className="ScoreComponent" style={{ backgroundColor: theme.main[0] }}>
      {t('game.corr-answ')} <span>{partialState}</span>
    </section>
  );
}
